<div class="wizard">
  <app-response-project-wizard-ai-typewriter
    [scenario]="aiScenario"
    [fileCount]="aiFileCount"
    [addedPhraseIndex]="addedPhraseIndex"
    [removedPhraseIndex]="removedPhraseIndex"
  />

  <app-response-project-document-uploader
    [title]="'tenders.responses.wizard.dce-title' | translate"
    [dragFormatsText]="'tenders.responses.wizard.dropzone-dragging-formats' | translate"
    [emptyStateSubhint]="'tenders.responses.documents.auto-categorize-hint' | translate"
    [mainTitle]="'tenders.responses.documents.empty-main-title-dce' | translate"
    scope="dce"
    [defaultDocumentSubtypeId]="defaultDceSubtypeId"
    [subtypeOptions]="dceSubtypeOptions"
    [projectId]="projectId"
    [collapsed]="panelsCollapsed"
    (uploadStateChange)="onDceUploaderChange($event)"
    (continueClicked)="onContinueClicked()"
    (projectNameChange)="onProjectNameChange($event)"
  ></app-response-project-document-uploader>

  @if (showInternalUploader) {
    <app-reference-documents-section
      class="wizard-uploader--internal"
      [title]="'tenders.responses.documents.section-internal' | translate"
      [defaultDocumentSubtypeId]="defaultInternalSubtypeId"
      [subtypeOptions]="internalSubtypeOptions"
      [projectId]="projectId"
      [collapsed]="panelsCollapsed"
      (uploadStateChange)="onInternalUploaderChange($event)"
      (continueClicked)="onInternalContinueClicked()"
    ></app-reference-documents-section>
  }

  @if (showInternalLaterLink) {
    <div class="wizard-internal-later">
      <div class="wizard-internal-later-separator">
        <span>{{ 'tenders.responses.wizard.internal-later-or' | translate }}</span>
      </div>
      <button type="button" class="wizard-internal-later-btn" (click)="onInternalLaterClick()">
        <i class="ph ph-arrow-right" aria-hidden="true"></i>
        {{ 'tenders.responses.wizard.internal-later-label' | translate }}
      </button>
    </div>
  }

  @if (showWordCard) {
    <app-response-project-wizard-word-card />
    <button type="button" class="wizard-later-btn" (click)="onLaterClick()">
      {{ 'tenders.responses.wizard.word-card-later' | translate }}
    </button>
  }

  <app-response-toast></app-response-toast>
</div>
